export const NONPROD = 'nonprod';
export const PROD = 'prod';

/**
 *
 * @returns 'nonprod' if on local or nonprod and 'prod' if on a live site
 * @description We can easily update this function in the future if someone tells us
 * "DO IT THIS OTHER AWESOME WAY INSTEAD!!!"
 */
const getEnv = () =>
	/.localhost.|.web-np./.test(document.domain) ? NONPROD : PROD;

export default getEnv;
